



















































import { Component, Prop, Vue } from 'vue-property-decorator';

import RoomListVue from './RoomList.vue';
import ModalVue from './Modal.vue';
import PopoverVue from './Popover.vue';

import Game from '../../engine/Game';
import Room from '../../engine/Room';

@Component({
    components: {
        RoomListVue,
        ModalVue,
        PopoverVue,
    },
})
export default class MobileButtonsVue extends Vue {

    @Prop() private game!: Game;

    show_rooms = false;
    show_inventory = false;

}

